import "./styles.scss";

import { Background, Container, Content, Section } from "layout";
import { useDevice } from "providers/AppProvider";
import { type JSX, memo, useEffect } from "react";
import { OverlayFade, SectionHeader, Separator, Vignette } from "ui/index";

import { Board, ClientQuilt, Planchette } from "./components";

function Clients(): JSX.Element {
  const { userDevice } = useDevice();
  const { isMobile } = userDevice;

  useEffect(() => {
    if (isMobile) return;

    const section = document.querySelector(".clients");
    if (!section) return;

    const handleMouseEnter = () => {
      document.body.style.cursor = "none";
    };

    const handleMouseLeave = () => {
      document.body.style.cursor = "default";
    };

    section.addEventListener("mouseenter", handleMouseEnter);
    section.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      section.removeEventListener("mouseenter", handleMouseEnter);
      section.removeEventListener("mouseleave", handleMouseLeave);
      document.body.style.cursor = "default";
    };
  }, [isMobile]);

  return (
    <Section className="clients">
      <Container className="clients__container">
        <Background>
          <div className="clients__ouija">
            <Board />
            {!isMobile && <Planchette />}
            <ClientQuilt />
            <Vignette />
            <OverlayFade opacity={0.2} />
          </div>
        </Background>
        <Content className="clients__content">
          <SectionHeader
            subtitle="Summon projects past with a click, conjured from beyond the veil."
            title="Client Archive"
            variant="dark"
          />
        </Content>
      </Container>
      <Separator />
    </Section>
  );
}

export default memo(Clients);
